export default __webpack_public_path__ + "static/media/school-three.57397f48.png";